import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { TableCell } from '@mui/material';
import { useTheme } from '@mui/system';
import { formatter } from '#component/shipment/helper';
import ShipmentStatus from '#component/shipment/status';
import AlertStatus from '#component/shipment/dashboard/alert-status';
import Devices from '#component/device/devices-chips';
import DateComponent from '#component/shipment/dashboard/table-view/date';
import DownloadShipment from '#component/shipment/dashboard/icon-download';
import HighlightWord from '#component/general/highlight-word';
import { getAddressString } from '#component/addressbook/helper';
import { getHighlightedSearchResult } from '#component/general/highlight-word/helper';
import {
  IconCnt,
  LabelCell,
  DeviceCell,
  DevicesCell,
  WordBreakCell,
  AddressCell,
  AddressCellEmpty,
  chipStyle,
  chipRootStyle
} from '#component/shipment/dashboard/table-view/styles';

export const ShipmentStatusCell = ({ data: s }) => (
  <TableCell width={60}>
    <IconCnt>
      <ShipmentStatus status={s.status} showTooltip />
    </IconCnt>
  </TableCell>
);

export const ShipmentAlertCell = ({ data: s }) => (
  <TableCell width={25}>
    <div><AlertStatus logs={s.logs} /></div>
  </TableCell>
);

export const ShipmentLabelCell = ({ data: shipment }) => {
  const uid = formatter(shipment.uid);
  const filter = useSelector(s => s.listFilter, shallowEqual) ?? {};
  const highlightedSearchResult = getHighlightedSearchResult(filter);
  return (
    <LabelCell>
      <div>
        {highlightedSearchResult ? <HighlightWord
          textToHighlight={shipment.label}
          searchWord={highlightedSearchResult}
        /> : shipment.label}
      </div>
      <div>
        {highlightedSearchResult ? <HighlightWord
          textToHighlight={uid}
          searchWord={highlightedSearchResult}
        /> : uid}
      </div>
    </LabelCell>
  );
};

export const ShipmentDevicesCell = ({ data: s }) => {
  const theme = useTheme();
  const CellComponent = s.devices?.length > 1 ? DevicesCell : DeviceCell;
  return (
    <CellComponent>
      <Devices
        devices={s.devices}
        isShipment
        styles={{ shipmentChip: chipStyle(theme), root: chipRootStyle }}
      />
    </CellComponent>
  );
};

export const ShipmentProjectCell = ({ data: shipment }) => {
  const filter = useSelector(s => s.listFilter, shallowEqual) ?? {};
  const highlightedSearchResult = getHighlightedSearchResult(filter);
  return (
    <WordBreakCell>
      {highlightedSearchResult ? <HighlightWord
        textToHighlight={shipment?.project?.title}
        searchWord={highlightedSearchResult}
      /> : shipment?.project?.title}
    </WordBreakCell>
  );
};

export const ShipmentStartDateCell = ({ data: s, account }) => {
  const origin = getAddressString(s?.delivery?.[0]?.address);
  const CellComponent = origin ? AddressCell : AddressCellEmpty;

  return (
    <CellComponent>
      <DateComponent date={s.startDate} origin={origin} account={account} />
    </CellComponent>
  );
};

export const ShipmentEndDateCell = ({ data: s, account }) => {
  const deliveryLength = s?.delivery?.length;
  const destination = deliveryLength > 1 ?
    getAddressString(s.delivery[deliveryLength - 1]?.address) : '';
  const CellComponent = destination ? AddressCell : AddressCellEmpty;

  return (
    <CellComponent>
      <DateComponent date={s.endDate} destination={destination} account={account} />
    </CellComponent>
  );
};

export const ShipmentDownloadCell = ({ data: s, account }) => (
  <TableCell align="right">
    <DownloadShipment account={account} shipment={s} />
  </TableCell>
);
